import type { ProjectDetail, ProjectType } from '@core/core/types'
import type { Nullable } from 'common/types'
import { useCallback, useState } from 'react'

import type { ComboItem, ProjectToAddInfo, ProjectToUpdateInfo } from '../types'

const emptyProject: ProjectToAddInfo = {
  name: '',
  type: null,
  year: new Date().getFullYear(),
  companyId: null,
  fieldId: null,
}

export const useProjectInfoEditor = (projectToUpdate?: ProjectDetail) => {
  const [project, setProject] = useState<ProjectToUpdateInfo>(projectToUpdate ?? emptyProject)

  const handleYearChange = useCallback((value: Nullable<Date>) => {
    if (value) {
      setProject(prev => ({ ...prev, year: value.getFullYear() }))
    }
  }, [])

  const handleNameChange = useCallback((value?: Nullable<string>) => {
    setProject(prev => ({ ...prev, name: value ?? '' }))
  }, [])

  const handleProjectTypeChange = useCallback((value: Nullable<ComboItem<ProjectType>>) => {
    if (value?.id) {
      setProject(prev => ({ ...prev, type: value.id }))
    }
  }, [])

  const handleOrgChange = useCallback((value: Nullable<ComboItem<string>>) => {
    // Обязательно сбросим месторождение, так как оно зависит от ДО
    setProject(prev => ({ ...prev, companyId: value?.id ?? undefined, fieldId: undefined }))
  }, [])

  const handleFieldChange = useCallback((value: Nullable<ComboItem<string>>) => {
    setProject(prev => ({ ...prev, fieldId: value?.id ?? undefined }))
  }, [])

  return {
    project,
    handleYearChange,
    handleNameChange,
    handleProjectTypeChange,
    handleOrgChange,
    handleFieldChange,
  }
}
